import React from 'react';
import './PostalCodeChangeModal.scss';
import { getUtilityLabels } from '../../../utils/commonUtils';
import AnimatedButton from '../../atoms/AnimatedButton/AnimatedButton';
import * as store from '../../../hooks/useStores';
import Cookies from 'js-cookie';

function PostalCodeChangeModal({ modalData, handleCloseModal }) {
  const utilityLabels = getUtilityLabels();
  const utilStore = store.useUtilityUiStore();

  const handleChangepostalCode = () => {
    utilStore.uiStore.updateLocationStored(modalData.validPostal);
    Cookies.remove('configId');
    window.location.reload();
  };

  return (
    <div className="postalChange__details_modal">
      <div className="postalChange__info">
        <h2 className="postalChange__name">{modalData.title}</h2>
        <div className="postalChange__description">
          <span className="description_text">{modalData.desc}</span>
        </div>
      </div>
      <div className="postalChange__button-holder">
        <AnimatedButton
          text={utilityLabels.userLocationModal.changePostalCode}
          theme="black"
          activeClass="active"
          clickHandler={handleChangepostalCode}
          extClasses="btn_width"
        />
        <AnimatedButton
          text={utilityLabels.userLocationModal.cancel}
          theme="white"
          activeClass="active"
          clickHandler={handleCloseModal}
          extClasses="btn_width"
        />
      </div>
    </div>
  );
}

export default PostalCodeChangeModal;
